import React, {Component} from 'react';
import Home from './home';
import './app.css';
import ContentPage from './content-page';
import Register from './register';
import Confirmation from './confirmation';
import Admin from './admin';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
import LoginCallback from './login-callback';
import {Navbar, Footer} from './components';
import {
  Grid
} from 'react-bootstrap/lib';
import {connect} from 'react-redux';
import {setAdmin} from './admin/actions';
import localStorage from './utils/local-storage';
import PropTypes from 'prop-types';

class App extends Component {

  constructor(props) {
    super(props);
    props.setAdmin(!!localStorage.getItem('jwt'));
  }

  render() {
    return (
      <Router>
        <Grid fluid={true}>
          <Navbar />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/register/:_id?" render={({location}) => <Register akey={location.key} />} />
            <Route path="/confirmation/:jwt" component={Confirmation} />
            <Route exact path="/admin" component={Admin} />
            <Route exact path="/login-callback/:jwtToken" component={LoginCallback} />
            <Route exact path="/about-us" component={ContentPage} />
            <Route exact path="/contact" render={() => {
              return <div>page 2</div>;
            }} />
          </Switch>
          <Footer />
        </Grid>
      </Router>
    );
  }
}

App.propTypes = {
  setAdmin: PropTypes.func.isRequired
};
const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    setAdmin: bool => dispatch(setAdmin(bool))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js